import { FC } from 'react';
import type { IInfoBox } from '@belong/types';
import { RichText } from '../../styles/Typography/RichText/RichText';
import Alert from '../Alert';

export const InfoBox: FC<IInfoBox> = ({
  message,
  level,
  dictionary,
  position = 'INLINE',
  role = 'none',
  ...alertProps
}) => {
  return (
    <Alert {...alertProps} position={position} role={role} type={level}>
      <RichText {...message} dictionary={dictionary} />
    </Alert>
  );
};

InfoBox.displayName = 'InfoBox';
